// Shared copy and example queries for analytics empty state. Single source of truth.

export const ANALYTICS_EMPTY_STATE = {
  heading: "How can I help you today?",
  description:
    "I can answer questions about device performance: speed, signal, battery, by yard or carrier. Try comparing yards or asking for top devices.",
};

export const ANALYTICS_EXAMPLE_QUERIES = {
  regular: [
    "Show me top 10 devices with slow upload speed",
    "Give me devices with slow upload speed in yard 207",
    "Top 10 devices with slow download speed",
    "Devices with slow upload speed on Verizon",
    "Show me top 5 devices with slow upload speed on T-Mobile",
    "Devices with slow download on T-Mobile",
  ],
  compare: [
    "Compare yard 207 vs yard 43 upload speed",
    "Compare Verizon vs AT&T upload speed",
    "Compare yard 207 vs yard 43 download speed",
    "Compare T-Mobile vs Verizon performance",
  ],
};
